import { render } from "./action-card.vue?vue&type=template&id=4d9f5286"
import script from "./action-card.vue?vue&type=script&lang=js"
export * from "./action-card.vue?vue&type=script&lang=js"

import "./action-card.vue?vue&type=style&index=0&id=4d9f5286&lang=scss"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__